import { Card, CardContent, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { getAllAssignmentSubmission } from '../../../../service/assignment.submission.service';
import { getAssignmentById } from '../../../../service/assignment.service';
import UserIcon from '../../../../svg/UserIcon';
import TestInfoCard from '../../../../components/TestInfoCard';
import palette from '../../../../theme/palette';
import NameAndChangeToScreenCard from '../../../../components/NameAndChangeToScreenCard';
import '../../../../css/upcomingTest.css';
import PageIcon from '../../../../svg/PageIcon';
import StudentList from './Teacher.StudentList';
import Header from '../../../../components/Header';
import { API_LIMIT_DATA } from '../../../../utils/constants';

export default function PreviousAsgnDetails({ asgnId, onBack }) {
  const [asgnDetail, setAsgnDetail] = useState({});
  const [selectedScreen, setSelScreen] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [offset, setOffset] = useState(1);
  const [hasMore, setHasMore] = useState();
  const [submissionList, setSubmissionList] = useState([]);
  const [totalSubmissionCount, setSubmissionCount] = useState(0);
  const [isDataLoading, setIsDataLoading] = useState(false);

  const fetchAsgnData = async () => {
    const res = await getAssignmentById(asgnId);
    if (res) {
      setAsgnDetail(res);
    }
    setLoading(false);
  };

  const fetchAsgnSubmissionList = async () => {
    await getAllAssignmentSubmission(asgnId, API_LIMIT_DATA, offset).then((res) => {
      setSubmissionList(res.results);
      setHasMore(res.results.length === API_LIMIT_DATA);
      setOffset(offset + 1);
      setSubmissionCount(res.totalResults);
    });
  };

  const fetchNextData = async () => {
    if (hasMore) {
      const res = await getAllAssignmentSubmission(asgnId, API_LIMIT_DATA, offset);
      if (res) {
        setSubmissionList((preResource) => [...preResource, ...res.results]);
        setHasMore(res.results.length === API_LIMIT_DATA);
        setOffset(offset + 1);
      }
      setIsDataLoading(false);
    }
  };

  useEffect(() => {
    fetchAsgnSubmissionList();
    fetchAsgnData();
  }, []);

  // const updateAsgnWithSolution = async (file) => {
  //   const fileRes = await uploadClassRoomFiles(asgnDetail.classId, file, 'assignment');
  //   if (fileRes) {
  //     getDownloadURL(fileRes.ref).then(async (url) => {
  //       const assignmentObj = {
  //         isSolutionUploaded: true,
  //         solutionURL: url
  //       };
  //       const asgnRes = await updateAssignment(asgnId, assignmentObj);
  //       if (asgnRes) {
  //         toast.success('Solution uploaded');
  //       } else {
  //         toast.error('Please try again later');
  //       }
  //     });
  //   } else {
  //     toast.error('Please try again later');
  //   }
  // };

  return (
    <div style={{ marginTop: 20 }}>
      {isLoading ? (
        <div style={{ textAlign: 'center', padding: '20% 0' }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          {/* eslint-disable-next-line */}
          {selectedScreen === null ? (
            <>
              <Header title={asgnDetail.name} onBack={onBack} />
              <TestInfoCard
                createdOn={moment(asgnDetail.createdAt).format('DD MMM, LT')}
                submissionDate={moment(asgnDetail.endDateTime).format('DD MMM, LT')}
              />
              {submissionList.length > 0 && (
                <Card style={{ marginTop: 25 }}>
                  <CardContent>
                    <NameAndChangeToScreenCard
                      title="Students Answers"
                      subTitle={
                        <>
                          <UserIcon
                            style={{ marginRight: 5 }}
                            color={palette.grey[500]}
                            width={12}
                            height={12}
                          />{' '}
                          {totalSubmissionCount}
                        </>
                      }
                      icon={<PageIcon color={palette.secondary.main} />}
                      onClick={() => setSelScreen('students')}
                    />
                  </CardContent>
                </Card>
              )}
            </>
          ) : (
            selectedScreen === 'students' && (
              <StudentList
                listArray={submissionList}
                fetchMore={fetchNextData}
                hasMore={hasMore}
                title={asgnDetail.name}
                isDataLoading={isDataLoading}
                setIsDataLoading={setIsDataLoading}
                onBack={() => setSelScreen(null)}
              />
            )
          )}
        </>
      )}
    </div>
  );
}

PreviousAsgnDetails.propTypes = {
  asgnId: PropTypes.string,
  onBack: PropTypes.func
};
